<section>
  <h2>Jetzt Termin vereinbaren und unverbindlich kennenlernen!</h2>

  <p>Vielen Dank für Ihr Interesse an video2manual.</p>
  <p>
    Mit unserer Software erleichtern wir Technischen Redakteuren,
    Arbeitsvorbereitern, aber auch Prozess- und Instandhaltungsmanagern die
    tägliche Arbeit.
  </p>
  <p>
    In nur drei Schritten erstellen Sie interaktive Video-Anleitungen. Mit einer
    (Smartphone)-Kamera und der Software video2manual haben Sie alles, was Sie
    brauchen.
  </p>
  <p>
    Utility Filme kommen in vielen Bereichen zum Einsatz: zu Montagezwecken, in
    der Wartung, für Schulungs- oder Servicezwecke. Die fertigen Anwendungen
    sind sprachfrei und textarm und somit international einsetzbar.
  </p>
  <div>
    <p>In unserem Termin erfahren Sie:</p>
    <ul>
      <li>was ein Utility Film ist,</li>
      <li>worin die Vorteile liegen,</li>
      <li>was bei der Aufnahme der Clips beachtet werden sollte und</li>
      <li>wie man aus den Clips einen Utility Film erstellt.</li>
    </ul>
    <p>
      Ihren persönlichen Termin können Sie unter der Rufnummer 02955 747 22-42
      oder per E-Mail:
      <a href="mailto:terminanfrage@video2manual.de?subject=Terminanfrage"
        >terminanfrage@video2manual.de</a
      >
      vereinbaren.
    </p>
    <p>
      Alternativ nutzen Sie gern das Anmeldeformular und wir werden uns
      schnellstmöglich mit Ihnen in Verbindung setzen.
    </p>
  </div>

  <form #form="ngForm">
    <section class="form appointment">
      <div class="text">Anmeldeformular</div>
      <div class="salutation">
        <select
          class="form-control"
          id="salutation"
          name="salutation"
          [(ngModel)]="salutation"
          [disabled]="isSending || isSended"
        >
          <option value="" disabled>Anrede</option>
          <option value="Frau">Frau</option>
          <option value="Herr">Herr</option>
        </select>
      </div>
      <div class="lastname">
        <input
          type="text"
          class="form-control"
          placeholder="Nachname"
          id="lastname"
          name="lastname"
          required
          [(ngModel)]="lastname"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="firstname">
        <input
          type="text"
          class="form-control"
          placeholder="Vorname"
          id="firstname"
          name="firstname"
          [(ngModel)]="firstname"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="email">
        <input
          type="email"
          class="form-control"
          placeholder="E-Mail-Adresse"
          id="email"
          name="email"
          required
          [(ngModel)]="email"
          [disabled]="isSending || isSended"
          required
        />
      </div>
      <div class="phone">
        <input
          type="text"
          class="form-control"
          placeholder="Telefonnummer"
          id="phone"
          name="phone"
          [(ngModel)]="phone"
          [disabled]="isSending || isSended"
        />
      </div>
      <div class="weekday">
        <div class="header">Gewünschter Wochentag</div>
        <input
          type="checkbox"
          id="weekday-monday"
          [(ngModel)]="monday"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="weekday-monday">Montag</label>
        <input
          type="checkbox"
          id="weekday-tuesday"
          [(ngModel)]="tuesday"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="weekday-tuesday">Dienstag</label>
        <input
          type="checkbox"
          id="weekday-wednesday"
          [(ngModel)]="wednesday"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="weekday-wednesday">Mittwoch</label>
        <input
          type="checkbox"
          id="weekday-thursday"
          [(ngModel)]="thursday"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="weekday-thursday">Donnerstag</label>
      </div>
      <div class="daytime">
        <div class="header">Gewünschte Tageszeit</div>
        <input
          type="checkbox"
          id="daytime-morning"
          [(ngModel)]="morning"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="daytime-morning">Vormittag</label>
        <input
          type="checkbox"
          id="daytime-afternoon"
          [(ngModel)]="afternoon"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="daytime-afternoon">Nachmittag</label>
      </div>
      <div class="privacy">
        <input
          type="checkbox"
          id="privacy"
          name="privacy"
          [(ngModel)]="privacy"
          [disabled]="isSending || isSended"
          required
        />
        <label for="privacy"
          >Ich erkenne den
          <a [routerLink]="['/privacy']">Datenschutz</a> an.</label
        >
      </div>
      <div class="send">
        <button
          class="send"
          (click)="send()"
          [disabled]="!form.form.valid || isSending || isSended"
        >
          Absenden
        </button>
      </div>
    </section>
  </form>
</section>
